<div class="login-bg">
	<div class="login-page">
		<div class="login-form">
			<form [formGroup]="formGroup" (ngSubmit)="activateAccount()">
				<img
					src="{{
						isCarsome
							? 'https://storage.googleapis.com/ps-asset/digi_rep/hero/dr_carsome-bg.png'
							: 'https://storage.googleapis.com/ps-asset/digi_rep/hero/dr-bg.png'
					}}"
					alt=""
					class="mobile-img"
				/>
				<mat-card class="form-field">
					<div class="sign-in-text">{{ "auth.accountActivation" | translate }}</div>
					<div class="pt-sm">{{ "auth.loginDesc" | translate }}</div>

					<mat-card-content class="pt-lg">
						<mat-form-field >
							<mat-label>{{ "auth.name" | translate }}</mat-label>
							<input
								matInput
								required
								[value]="name"
								[disabled]="true"
							/>
						</mat-form-field>
						<mat-form-field >
							<mat-label>{{ "auth.yourEmail" | translate }}</mat-label>
							<input
								matInput
								required
								[value]="email"
								[disabled]="true"
							/>
						</mat-form-field>
						<mat-form-field >
							<mat-label>{{ "auth.mobileNo" | translate }}</mat-label>
							<input
								matInput
								required
								[value]="mobileNo"
								[disabled]="true"
							/>
						</mat-form-field>
						<div class="input-with-icon">
							<mat-form-field >
								<mat-label>{{ "auth.yourPass" | translate }}</mat-label>
								<input
									matInput
									[type]="hide ? 'password' : 'text'"
									formControlName="newPassword"
									(ngModelChange)="getNewPasswordLength($event)"
									required
								/>
								<button
									type="button"
									mat-icon-button
									matSuffix
									(click)="hide = !hide"
									[attr.aria-label]="'Hide password'"
									
									[attr.aria-pressed]="hide"
								>
									<mat-icon>{{
										hide ? "visibility_off" : "visibility"
									}}</mat-icon>
								</button>
								<mat-error
									*ngIf="(f.newPassword.dirty) && !requiredValid"
								>
									{{ "error.newPassRequired" | translate }}
								</mat-error>
							</mat-form-field>
							<mat-icon
								class="tooltip-icon"
								[matMenuTriggerFor]="typeTooltip"
								#typeTrigger="matMenuTrigger"
								(mouseenter)="typeTrigger.openMenu()"
							>
								help
							</mat-icon>
							<mat-menu
								#typeTooltip="matMenu"
								[overlapTrigger]="false"
								class="tooltip-popover dashboard"
							>
								<span (mouseleave)="typeTrigger.closeMenu()">
									<ul class="info-detail-css">
										<li>{{ "error.condition_1" | translate }}</li>
										<li>{{ "error.condition_2" | translate }}</li>
										<li>{{ "error.condition_3" | translate }}</li>
									</ul>
								</span>
							</mat-menu>
						</div>
						<mat-form-field >
							<mat-label>{{ "auth.repeatNewPass" | translate }}</mat-label>
							<input
								matInput
								[type]="hide ? 'password' : 'text'"
								formControlName="repeatNewPassword"
								(ngModelChange)="getRepeatNewPasswordLength($event)"
								required
							/>
 							<button
								type="button"
								mat-icon-button
								matSuffix
								(click)="hide = !hide"
								[attr.aria-label]="'Hide password'"
								[attr.aria-pressed]="hide"
							>
								<mat-icon>{{
									hide ? "visibility_off" : "visibility"
								}}</mat-icon>
							</button>
							<mat-error
								*ngIf="
									(f.repeatNewPassword.dirty) && !requiredValid
								"
							>
								{{ "error.repeatPassRequired" | translate }}
							</mat-error>
						</mat-form-field>

						<!-- Errors here -->
						<mat-error
							*ngIf="
								(f.newPassword.dirty &&
									f.newPassword.errors &&
									f.newPassword.errors.requiresDigit) ||
								(f.newPassword.dirty &&
									f.newPassword.errors &&
									f.newPassword.errors.requiresLowercase)
							"
						>
							<li>
								{{ "error.alphanumeric" | translate }}
							</li>
						</mat-error>
						<mat-error
							*ngIf="
								(f.newPassword.dirty && !newPassLength) ||
								(f.repeatNewPassword.dirty && !repeatNewPassLength)
							"
						>
							<li>
								{{ "error.atLeastLength" | translate }}
							</li>
						</mat-error>
						<mat-error
							*ngIf="
								f.newPassword.dirty &&
								f.newPassword.errors &&
								f.newPassword.errors.requiresSpecialChars
							"
						>
							<li>
								{{ "error.oneSpecialChar" | translate }}
							</li>
						</mat-error>
						<mat-error
							*ngIf="
								(f.repeatNewPassword.dirty) &&
								f.repeatNewPassword.errors &&
								f.repeatNewPassword.errors.required
							"
						>
							<li>	
								{{ "error.confirmPass" | translate }}
							</li>
						</mat-error>
						<mat-error
							*ngIf="
								(f.repeatNewPassword.dirty) &&
								f.repeatNewPassword.errors &&
								f.repeatNewPassword.errors.mismatch
							"
						>
							<li>
								{{ "error.passNoMatch" | translate }}
							</li>
						</mat-error>						
						<!-- End Errors here -->
		
						<button
							mat-raised-button
							color="primary"
							class="lg"
							[disabled]="formGroup.invalid"
						>
							{{ "common.submit" | translate }}
						</button>
					</mat-card-content>
				</mat-card>
			</form>
		</div>
		<div class="crm-info">
			<img
				src="{{
					isCarsome
						? 'https://storage.googleapis.com/ps-asset/digi_rep/hero/dr_carsome-bg.png'
						: 'https://storage.googleapis.com/ps-asset/digi_rep/hero/dr-bg.png'
				}}"
				alt="mockup-1"
			/>
		</div>
	</div>
</div>
